var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-clients-welcome d-flex flex-column align-items-center"},[_c('img',{attrs:{"src":"/images/bitacorapp-logo.png","alt":""}}),_vm._v(" "),_c('h2',{staticClass:"mt-4 text-center"},[_vm._v("Bienvenido al módulo de administración del cliente de Bitacorapp")]),_vm._v(" "),_c('h3',[_vm._v("Cliente: "+_vm._s(_vm.client.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }